import { Component, inject } from '@angular/core';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { SafePipe } from '../../core/pipes/safe.pipe';

@Component({
  selector: 'app-contact',
  imports: [SafePipe],
  templateUrl: './contact.html',
  styleUrl: './contact.scss',
})
export class Contact {
  private readonly sanitizer = inject(DomSanitizer);

  environment = environment;
  contact: any = environment.ContactConfig;
  booking: any = environment.BookingConfig;
  mapUrl: SafeResourceUrl;

  constructor() {
    this.mapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.contact.address.embedMapUrl
    );
  }
}
